import React, { Component } from "react";
import {
  Col,
  Row,
  Card,
  CardDeck,
  CardBody,
  CardTitle,
  CardText
} from "reactstrap";

class Servicesinsert extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <React.Fragment>
        <div className="servicesInsert">
          <Row className="align-items-center justify-content-center">
            <Col md="auto" className="m-4 text-white">
              <h2>What services are you looking for?</h2>
            </Col>
          </Row>
          <div className="w-100" />
          <CardDeck>
            <Card>
              <CardBody>
                <CardTitle>Get a Website</CardTitle>
                <CardText>
                  Get a great website for your business. We can deliver simple,
                  static websites, or web applications that can interact with
                  your existing business logic and practices. We build our sites
                  to perform, and to perform fast.
                </CardText>
                <CardText>
                  Comes with One Year of free hosting, then Pay As You Go. Bring
                  your own domain, or register one with{" "}
                  <a
                    href="https://www.panthur.com.au/domains"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    our recommended registrar, Panthur.
                  </a>
                </CardText>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <CardTitle>Card</CardTitle>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <CardTitle>Card</CardTitle>
              </CardBody>
            </Card>
          </CardDeck>
        </div>
      </React.Fragment>
    );
  }
}

export default Servicesinsert;



// WEBPACK FOOTER //
// ./src/components/Servicesinsert.js